import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { BaseEditField, DynamicFormOptions } from './models/edit-fields';
import { UntypedFormGroup } from '@angular/forms';
import { DynamicFormHelperService } from './services/dynamic-form.service';

@Component({
    selector: 'app-dynamic-form',
    templateUrl: './dynamic-form.component.html',
    styleUrls: ['./dynamic-form.component.scss'],
    standalone: false
})
export class DynamicFormComponent implements OnInit {
  @Input() dynamicFormOptions: DynamicFormOptions;
  _formInitialData: any;
  get formInitialData(): any {
    return this._formInitialData;
  }
  @Input() set formInitialData(newFormInitialData: any) {
    this._formInitialData = newFormInitialData;
    if (newFormInitialData) this.patchForm(newFormInitialData);
  }
  @Input() isSubmitting: boolean = false;
   @Input() successMessage:string = null;

  @Output() formSubmitted = new EventEmitter<UntypedFormGroup>();
  @Output() itemDeleted = new EventEmitter();

  dynamicForm: UntypedFormGroup;

  fieldColumns: BaseEditField[][] = [];

  constructor(private editFormService: DynamicFormHelperService) {}

  ngOnInit(): void {
     if (!this.dynamicFormOptions.columns || this.dynamicFormOptions.columns === 0)
        this.dynamicFormOptions.columns = 1;

    this.dynamicForm = this.editFormService.createEditForm(
      this.dynamicFormOptions
    );

    this.splitIntoColumns();
  }

  submitForm() {
    this.formSubmitted.emit(this.dynamicForm);
  }

  deleteItem() {
    this.itemDeleted.emit();
  }

  private patchForm(form: any) {
    this.dynamicForm.patchValue(form);
  }

   private splitIntoColumns(): void {
    this.fieldColumns = Array.from({ length: this.dynamicFormOptions.columns }, () => []);
    this.dynamicFormOptions.fields.forEach((field, index) => {
      this.fieldColumns[index % this.dynamicFormOptions.columns].push(field);
    });
  }
}
